import React from "react";
import ClauseStaticDocument from "../ClauseStaticDocument";
import "../privacy.css";
import {
  PRIVACY_V11_EFFECTIVE_AT,
  PRIVACY_V12_EFFECTIVE_AT,
  PRIVACY_V12_NOTICE_START_AT,
  getCurrentBiztingPrivacyRoute,
  getScheduledBiztingPrivacyRoute,
} from "../clauseVersionDates";

const styles = "\n      .cursor{display: none !important;}\n    ";

const PrivacyV10Document = () => {
  const now = new Date();
  const isV11Effective = now >= PRIVACY_V11_EFFECTIVE_AT;
  const isV12NoticeStarted = now >= PRIVACY_V12_NOTICE_START_AT;
  const isV12Effective = now >= PRIVACY_V12_EFFECTIVE_AT;
  const currentRoute = getCurrentBiztingPrivacyRoute(now);
  const scheduledRoute = getScheduledBiztingPrivacyRoute(now);

  return (
    <ClauseStaticDocument styles={styles}>
    <main
      className="fs-6 aos-init aos-animate"
      data-aos="fade-in"
      data-aos-delay="50"
      style={{ maxWidth: "1000px", margin: "0 auto", width: "100%" }}
    >
      <section className="title-contents pb-0">
        <div className="container">
          <div className="mb-md-2 aos-init aos-animate" data-aos="fade-up" data-aos-delay="600" data-aos-once="false">
            <span className="subscript">
              {"\n              Poilcy\n            "}
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "16px", flexWrap: "wrap"  }}>
            <h1 data-aos="fade-up" data-aos-delay="400" data-aos-once="false" className="aos-init aos-animate" style={{ margin: "0"  }}>
              {"\n              개인정보 처리방침\n            "}
            </h1>
            <div className="clause-version-nav" style={{ display: "flex", justifyContent: "flex-end", gap: "8px", flexWrap: "wrap"  }}>
              {isV12Effective ? (
                <>
                  {scheduledRoute && (
                    <button type="button" className="clause-version-btn" data-route={scheduledRoute} style={{ appearance: "none", border: "1px solid #cbd5e1", background: "#fff", color: "#334155", borderRadius: "999px", padding: "9px 16px", fontSize: "13px", fontWeight: "600", cursor: "pointer", fontFamily: "inherit"  }}>
                      {"예정 버전"}
                    </button>
                  )}
                  <button type="button" className="clause-version-btn" data-route={currentRoute} style={{ appearance: "none", border: "1px solid #cbd5e1", background: "#fff", color: "#334155", borderRadius: "999px", padding: "9px 16px", fontSize: "13px", fontWeight: "600", cursor: "pointer", fontFamily: "inherit"  }}>
                    {"현재 버전"}
                  </button>
                </>
              ) : isV12NoticeStarted ? (
                <>
                  <button type="button" className="clause-version-btn" data-route="/clause/privacy" style={{ appearance: "none", border: "1px solid #cbd5e1", background: "#fff", color: "#334155", borderRadius: "999px", padding: "9px 16px", fontSize: "13px", fontWeight: "600", cursor: "pointer", fontFamily: "inherit"  }}>
                    {"예정 버전"}
                  </button>
                  <button type="button" className="clause-version-btn" data-route="/clause/privacy/v1.1" style={{ appearance: "none", border: "1px solid #cbd5e1", background: "#fff", color: "#334155", borderRadius: "999px", padding: "9px 16px", fontSize: "13px", fontWeight: "600", cursor: "pointer", fontFamily: "inherit"  }}>
                    {"현재 버전"}
                  </button>
                </>
              ) : isV11Effective ? (
                <>
                  <button type="button" className="clause-version-btn" data-route="/clause/privacy/v1.1" style={{ appearance: "none", border: "1px solid #cbd5e1", background: "#fff", color: "#334155", borderRadius: "999px", padding: "9px 16px", fontSize: "13px", fontWeight: "600", cursor: "pointer", fontFamily: "inherit"  }}>
                    {"현재 버전"}
                  </button>
                </>
              ) : (
                <>
                  <button type="button" className="clause-version-btn" data-route="/clause/privacy" style={{ appearance: "none", border: "1px solid #cbd5e1", background: "#fff", color: "#334155", borderRadius: "999px", padding: "9px 16px", fontSize: "13px", fontWeight: "600", cursor: "pointer", fontFamily: "inherit"  }}>
                    {"예정 버전"}
                  </button>
                  <button type="button" className="clause-version-btn is-active" data-route="/clause/privacy/v1.0" style={{ appearance: "none", border: "1px solid #2563eb", background: "#2563eb", color: "#fff", borderRadius: "999px", padding: "9px 16px", fontSize: "13px", fontWeight: "600", cursor: "pointer", fontFamily: "inherit"  }}>
                    {"현재 버전"}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="container-xxl" style={{ maxWidth: "1000px", margin: "0 auto", padding: 0, width: "100%" }}>
        <div>
          <div className="terms" style={{ maxWidth: "1000px", margin: "0 auto", width: "100%", boxSizing: "border-box" }}>
            <div>
              <div className="header-title">
                <span style={{ fontSize: "16px", color: "#212529"  }}>
                  {"공고일 : 2025-07-18 "}
                </span>
              </div>
              <article className="content" style={{ display: "block"  }}>
                <p style={{ marginBottom: "20px"  }}>
                  {"비즈톡 주식회사(이하 '회사'라 한다)는 정보주체의 자유와 권리 보호를 위해 「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. 이에 「개인정보 보호법」 제30조에 따라 정보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립 ‧ 공개합니다."}
                </p>
                <table className="table_privacy">
                  <tbody>
                    <tr>
                      <th colSpan={2}>
                        {"<목차>"}
                      </th>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr>
                      <td>
                        <a href="#no1">
                          {"1. 개인정보의 처리 목적"}
                        </a>
                      </td>
                      <td>
                        <a href="#no7">
                          {"7. 정보주체와 법정대리인의 권리의무 및 행사방법"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a href="#no2">
                          {"2. 개인정보의 보유 및 이용 기간"}
                        </a>
                      </td>
                      <td>
                        <a href="#no8">
                          {"8. 개인정보의 안전성 확보조치"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a href="#no3">
                          {"3. 처리하는 개인정보의 항목"}
                        </a>
                      </td>
                      <td>
                        <a href="#no9">
                          {"9. 개인정보 보호책임자"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a href="#no4">
                          {"4. 개인정보의 자동 수집 장치의 설치 운영 및 거부에 관한 관한 사항"}
                        </a>
                      </td>
                      <td>
                        <a href="#no10">
                          {"10. 개인정보 열람청구"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a href="#no5">
                          {"5. 개인정보 처리업무의 위탁에 관한 사항"}
                        </a>
                      </td>
                      <td>
                        <a href="#no11">
                          {"11. 권익침해 구제방법"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <a href="#no6">
                          {"6. 개인정보의 파기"}
                        </a>
                      </td>
                      <td>
                        <a href="#no12">
                          {"12. 영상정보 처리기기 운영·관리 방침"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        <a href="#no13">
                          {"13. 개인정보 처리방침의 변경"}
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <dl className="main" id="no1">
                  <dt>
                    {"1. 개인정보의 처리 목적 "}
                  </dt>
                  <dd>
                    {"회사는 다음의 목적을 위하여 최소한의 개인정보를 수집하여 처리합니다. 처리하고 있는 개인정보는 다음 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다."}
                  </dd>
                </dl>
                <dl className="item">
                  <dd>
                    {"① 서비스 제공 및 운영: 서비스 신청 및 승낙사항에 대한 이행, 서비스 제공에 따른 요금정산, 콘텐츠 제작 및 제공, 부정가입 방지를 위한 본인인증, 당사의 AGENT 모듈 또는 API 연동, 이용내역서 및 계산서 발행, 미납요금추심"}
                  </dd>
                  <dd>
                    {"② 이용자 관리: 본인확인, 개인식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 중복가입 확인, 이용신청 확인, 분쟁 조정을 위한 기록보전, 불만처리 등 민원처리, 고지사항 전달, 이용자 요청에 따른 이용내역(이용정보) 제공, 서비스이용에 대한 통계."}
                  </dd>
                </dl>
                <dl className="main" id="no2">
                  <dt>
                    {"2. 개인정보의 보유 및 이용 기간 "}
                  </dt>
                </dl>
                <dl className="item">
                  <dd>
                    {"① 회사는 이용자의 개인정보를 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기됩니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다."}
                  </dd>
                  <dd>
                    {"② 회사 내부 방침에 의한 정보보유 사유"}
                    <br />
                    <table className="item-table">
                      <tbody>
                        <tr>
                          <th>
                            {"보관사유"}
                          </th>
                          <th>
                            {"보관정보"}
                          </th>
                          <th>
                            {"보유기간"}
                          </th>
                        </tr>
                        <tr>
                          <td>
                            {"부정 이용 방지"}
                          </td>
                          <td>
                            {"부정이용기록(ID, 대표자명)"}
                          </td>
                          <td>
                            {"1년"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"고객문의 응대"}
                          </td>
                          <td>
                            {"이름, 연락처, "}
                            <br />
                            {"\n                                            이메일, 문의내용\n                                        "}
                          </td>
                          <td>
                            {"90일"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"간편가입/챗봇 도입시"}
                          </td>
                          <td>
                            {"연락처, 이메일"}
                          </td>
                          <td>
                            {"90일"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </dd>
                  <dd>
                    {"③ 상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다."}
                    <br />
                    <table className="item-table">
                      <tbody>
                        <tr>
                          <th>
                            {"보존근거"}
                          </th>
                          <th>
                            {"보유항목"}
                          </th>
                          <th>
                            {"보유기간"}
                          </th>
                        </tr>
                        <tr>
                          <td>
                            {"통신비밀보호법 제15조의 2"}
                            <br />
                            {"(전기통신사업자의 협조의무)"}
                          </td>
                          <td>
                            {"웹사이트 방문에 관한 기록"}
                          </td>
                          <td>
                            {"3개월"}
                          </td>
                        </tr>
                        <tr>
                          <td rowSpan={3}>
                            {"전자상거래법 제6조"}
                            <br />
                            {"(거래기록의 보존 등)"}
                          </td>
                          <td>
                            {"대금 결제 및 재화 등의 공급에 관한 기록"}
                          </td>
                          <td>
                            {"5년"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"계약 또는 청약철회 등에 관한 기록"}
                          </td>
                          <td>
                            {"5년"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"소비자 불만 또는 분쟁 처리에 관한 기록"}
                          </td>
                          <td>
                            {"3년"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"전기통신사업법 제83조"}
                            <br />
                            {"(통신비밀의 보호)"}
                          </td>
                          <td>
                            {"통신이용자정보"}
                          </td>
                          <td>
                            {"1년"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {"\n                                ※ 전자상거래법에 따라 필요한 항목은 최대 5년까지 보관 후 즉시 삭제되며, 그 외의 사항은 본 개인정보처리방침에 따라 정한 기준에 따라 처리됩니다.\n                            "}
                  </dd>
                </dl>
                <dl className="main" id="no3">
                  <dt>
                    {"3. 처리하는 개인정보의 항목 "}
                  </dt>
                </dl>
                <dl className="item">
                  <dd>
                    {"① 법인회원(필수): 법인명(국문), 대표자명, 사업자등록번호, 법인번호, 주소, 업태, 업종, 서비스 담당자 정보(부서명, 성명, 전화번호, 이동전화번호, E-mail), 사업자등록증(개인 사업자의 경우 신청자의 신분증 사본), 아이디, 비밀번호, 정산 담당자 정보(부서명, 성명, 전화번호, 이동전화번호, E-mail)"}
                  </dd>
                  <dd>
                    {"② 법인회원(선택): 개발담당자 정보(부서명, 성명, 전화번호, 이동전화번호, E-mail), 사업자구분, 팩스, 회신번호, 홈페이지, 직책, 메일서비스 수신여부, 문자서비스 수신여부"}
                  </dd>
                  <dd>
                    {"③ 개인사업자: 대표자명, 사업자등록번호, 사업자정보, 주소, 업태, 업종, 서비스 담당자 정보(부서명, 성명, 전화번호, 이동전화번호, E-mail), 사업자등록증, 대표자 신분증 사본(뒷자리 마스킹), 아이디, 비밀번호, 정산 담당자 정보(부서명, 성명, 전화번호, 이동전화번호, E-mail)"}
                  </dd>
                  <dd>
                    {"④ 서비스 이용 또는 업무처리 과정에서 생성 또는 수집될 수 있는 정보(정산기록, 이용현황, 콘텐츠 및 메시지 내용 등)"}
                  </dd>
                  <dd>
                    {"⑤ 서비스 이용 과정에서 아래와 같은 정보들이 자동으로 생성 및 수집될 수 있습니다."}
                    <br />
                    {"\n                                - IP Address, 쿠키, 방문 일시, 서비스 이용 기록, 불량 이용 기록"}
                  </dd>
                  <dd>
                    {"⑥ 유료 서비스 이용 과정에서 아래와 같은 정보들이 수집될 수 있습니다. (선불 서비스)"}
                    <br />
                    {"\n                                - 계좌이체 시: 은행명, 계좌번호 (단, 회원이 서비스에 게시한 게시물은 본 개인정보취급 및 보호정책에 따라서 공개된 정보로 간주되고, 개인 신상에 관한 정보로 판단하지 아니합니다.)"}
                  </dd>
                  <dd>
                    {"⑦ 상담 신청 과정에서 아래와 같은 정보들이 수집될 수 있습니다."}
                    <br />
                    {"\n                                - 성명, 연락처, E-mail\n                            "}
                  </dd>
                  <dd>
                    {"⑧ 챗봇 서비스 상담 시 체크리스트 내 아래와 같은 정보들이 수집될 수 있습니다."}
                    <br />
                    {"\n                                - 성명, 전화번호, E-mail\n                            "}
                  </dd>
                  <dd>
                    {"⑨ 간편가입 서비스 상담 시 체크리스트 내 아래와 같은 정보들이 수집될 수 있습니다."}
                    <br />
                    {"\n                                - 성명, 전화번호, E-mail\n                            "}
                  </dd>
                </dl>
                <dl className="main" id="no4">
                  <dt>
                    {"4. 개인정보의 자동 수집 장치의 설치 운영 및 거부에 관한 관한 사항"}
                  </dt>
                  <dd>
                    {"이용자 개개인에게 개인화되고 맞춤화 된 서비스를 제공하기 위해서 회사는 이용자의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 사용자의 브라우저에게 보내는 조그마한 데이터 꾸러미로 이용자 컴퓨터의 하드디스크에 저장됩니다."}
                  </dd>
                </dl>
                <dl className="item">
                  <dd>
                    {"① 쿠키의 사용 목적 회원과 비회원의 접속 빈도나 방문 시간 등의 분석, 이용자의 취향과 관심분야의 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공"}
                  </dd>
                  <dd>
                    {"② 쿠키 설정 거부 방법 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다."}
                  </dd>
                  <dd>
                    {"* 설정방법 예(인터넷 익스플로러의 경우): 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보(단, 쿠키 설치를 거부하였을 경우 로그인이 필요한 일부 서비스의 이용이 어려울 수 있습니다.)"}
                  </dd>
                </dl>
                <dl className="main">
                  <dd>
                    {"회사는 구글(Google)에서 제공하는 Google Analytics를 사용하여 웹사이트 이용 통계를 분석하고 서비스 개선에 활용하고 있습니다. Google Analytics를 통해 개인을 식별할 수 있는 정보는 수집되지 않습니다."}
                  </dd>
                </dl>
                <dl className="item">
                  <dd>
                    {"① Analytics 사용 목적: 서비스 이용 통계 분석 및 품질 개선"}
                  </dd>
                  <dd>
                    {"② Analytics 설치·운영 및 거부 방법:\n                                "}
                    <br />
                    {"- Google에서 제공하는 Google Analytics 차단 브라우저 부가 기능(add-on)을 설치하여 수집을 거부할 수 있습니다.\n                                "}
                    <br />
                    {"- [차단 기능 다운로드 링크] "}
                    <a href="https://tools.google.com/dlpage/gaoptout">
                      {"https://tools.google.com/dlpage/gaoptout"}
                    </a>
                  </dd>
                  <dd>
                    {"③ Analytics 정보의 처리를 거부할 경우, 맞춤형 서비스 제공이 일부 제한될 수 있습니다."}
                  </dd>
                </dl>
                <dl className="main" id="no5">
                  <dt>
                    {"5. 개인정보 처리업무의 위탁에 관한 사항"}
                  </dt>
                  <dd>
                    {"회사는 서비스 제공을 위해 아래와 같이 개인정보 처리 업무를 외부 업체에 위탁하여 운영하고 있습니다. 위탁계약 체결 시 개인정보보호의 안전을 기하기 위하여 위탁계약 내용에 개인정보보호 관련 지시 엄수, 개인정보의 유출금지 및 사고시의 책임부담 등을 명확히 규정하고 있습니다."}
                  </dd>
                </dl>
                <dl className="item">
                  <dd>
                    <table className="item-table">
                      <tbody>
                        <tr>
                          <th>
                            {"수탁업체"}
                          </th>
                          <th>
                            {"업무위탁의 내용"}
                          </th>
                          <th>
                            {"보유 및 이용기간"}
                          </th>
                        </tr>
                        <tr>
                          <td>
                            {"카카오"}
                          </td>
                          <td>
                            {"알림톡 및 친구톡 메시지 발송"}
                          </td>
                          <td rowSpan={12}>
                            {"위탁 계약 종료 시"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"네이버"}
                          </td>
                          <td>
                            {"스마트 알림 발송"}
                          </td>
                        </tr>
                        <tr>
                          <td rowSpan={2}>
                            {"인포뱅크"}
                          </td>
                          <td>
                            {"톡투비즈 시스템 운영 및 개발"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"문자메시지, RCS 발송"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"LGU+"}
                          </td>
                          <td>
                            {"문자메시지, RCS 발송"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"엔아이티소프트"}
                          </td>
                          <td>
                            {"문자메시지, RCS 발송"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"BGF네트웍스"}
                          </td>
                          <td>
                            {"문자메시지, RCS 발송"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"KG이니시스"}
                          </td>
                          <td>
                            {"전자거래(선불 서비스)"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"KSNET"}
                          </td>
                          <td>
                            {"전자거래(선불 서비스)"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"KCB"}
                          </td>
                          <td>
                            {"휴대폰 본인인증"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"다날"}
                          </td>
                          <td>
                            {"휴대폰 본인인증"}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {"AWS(서울리전)"}
                          </td>
                          <td>
                            {"클라우드 서비스"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </dd>
                </dl>
                <dl className="main" id="no6">
                  <dt>
                    {"6. 개인정보의 파기 절차 및 방법에 관한 사항 "}
                  </dt>
                  <dd>
                    {"회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다."}
                  </dd>
                </dl>
                <dl className="item">
                  <dt>
                    {"① 파기계획 수립"}
                  </dt>
                  <dd>
                    {"회사는 내부 방침 및 관련 법령에 따라 개인정보 파기계획을 수립합니다."}
                  </dd>
                  <dt>
                    {"② 파기절차 및 기한"}
                  </dt>
                  <dd>
                    {"이용자가 입력한 정보는 보유기간이 경과했거나 처리목적이 달성된 후 지체 없이 파기합니다."}
                  </dd>
                  <dt>
                    {"③ 파기방법"}
                  </dt>
                  <dd>
                    {"회사는 처리하는 개인정보를 파기할 때에는 다음의 방법으로 파기 합니다."}
                  </dd>
                  <dd>
                    {"1) 전자적 파일 형태인 경우 : 복원이 불가능한 방법으로 영구삭제"}
                  </dd>
                  <dd>
                    {"2) 전자적 파일의 형태 외의 기록물, 인쇄물, 서면, 그 밖의 기록매체인 경우 : 파쇄 또는 소각"}
                  </dd>
                </dl>
                <dl className="main" id="no7">
                  <dt>
                    {"7. 정보주체와 법정대리인의 권리의무 및 행사방법"}
                  </dt>
                </dl>
                <dl className="item">
                  <dt>
                    {"① 정보주체는 회사에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다."}
                  </dt>
                  <dd>
                    {"※ 만 14세 미만 아동에 관한 개인정보의 열람 등 요구는 법정대리인이 직접 해야 하며, 만 14세 이상의 미성년자인 정보주체는 정보주체의 개인정보에 관하여 미성년자 본인이 권리를 행사하거나 법정대리인을 통하여 권리를 행사할 수도 있습니다."}
                  </dd>
                  <dt>
                    {"② 권리 행사는 회사에 대해 「개인정보 보호법」 시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체없이 조치하겠습니다."}
                  </dt>
                  <dt>
                    {"③ 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수도 있습니다. 이 경우 “개인정보 처리 방법에 관한 고시(제2020-7호)” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다."}
                  </dt>
                  <dt>
                    {"④ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한 될 수 있습니다."}
                  </dt>
                  <dt>
                    {"⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다."}
                  </dt>
                  <dt>
                    {"⑥ 회사는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다."}
                  </dt>
                  <dt>
                    {"⑦ 정보주체가 마케팅 정보 수신에 대한 동의 또는 거부를 한 경우, 회사는 이를 즉시 반영하며 그 처리 결과를 이메일 또는 알림톡 등을 통해 통지합니다."}
                  </dt>
                </dl>
                <dl className="main" id="no8">
                  <dt>
                    {"8. 개인정보의 안전성 확보조치 "}
                  </dt>
                  <dd>
                    {"회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다."}
                  </dd>
                </dl>
                <dl className="item">
                  <dt>
                    {"① 기술적인 대책"}
                  </dt>
                  <dd>
                    {"1) 회사는 이용자의 개인정보를 관련 법률규정 및 내부정책에 따라 보안기능을 통해 안전하게 보호하고 있습니다."}
                  </dd>
                  <dd>
                    {"2) 회사는 백신프로그램을 이용하여 컴퓨터 바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있습니다. 백신프로그램은 주기적으로 업데이트되며 갑작스러운 바이러스가 출현될 경우 백신이 나오는 즉시 이를 적용함으로써 개인정보가 침해되는 것을 방지하고 있습니다."}
                  </dd>
                  <dd>
                    {"3) 회사는 네트워크 상의 개인정보를 안전하게 전송할 수 있는 보안장치를 채택하고 있습니다."}
                  </dd>
                  <dd>
                    {"4) 회사는 해킹 등에 의해 이용자의 개인정보가 유출되는 것을 방지하기 위하여, 외부로부터의 침입을 차단하는 장치를 이용하고 있으며 24시간 X 365일 침입을 감시하고 있습니다."}
                  </dd>
                  <dt>
                    {"② 관리적인 대책"}
                  </dt>
                  <dd>
                    {"1) 회사는 개인정보 처리직원을 개인정보 관리업무를 수행하는 자 및 업무상 개인정보의 처리가 불가피 한 자로 엄격히 제한하고 담당직원에 대한 수시 교육을 통하여 개인정보처리방침의 준수를 강조하고 있습니다."}
                  </dd>
                </dl>
                <dl className="main" id="no9">
                  <dt>
                    {"9. 개인정보 보호책임자  "}
                  </dt>
                  <dd>
                    {"회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다."}
                  </dd>
                </dl>
                <dl className="item">
                  <dd>
                    <table className="item-table">
                      <tbody>
                        <tr>
                          <th>
                            {"개인정보 보호책임자"}
                          </th>
                          <td>
                            {"정의영"}
                          </td>
                          <td>
                            {"전화:1688-3764"}
                          </td>
                          <td rowSpan={2}>
                            {"이메일: biztalk_privacy@biztalk.co.kr"}
                          </td>
                        </tr>
                        <tr>
                          <th>
                            {"개인정보 보호담당자"}
                          </th>
                          <td>
                            {"박영하"}
                          </td>
                          <td>
                            {"전화:070-8896-7359"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </dd>
                </dl>
                <dl className="main" id="no10">
                  <dt>
                    {"10. 개인정보 열람청구  "}
                  </dt>
                  <dd>
                    {"① 정보주체는 「개인정보 보호법」 제35조에 따른 개인정보의 열람청구를 아래의 부서에 할 수 있습니다. 회사는 정보주체의 개인정보 열람청구가 신속하게 처리되도록 하겠습니다."}
                  </dd>
                </dl>
                <dl className="item">
                  <dd>
                    <table className="item-table">
                      <tbody>
                        <tr>
                          <th>
                            {"부서명"}
                          </th>
                          <th>
                            {"개인정보파일"}
                          </th>
                          <th>
                            {"연락처"}
                          </th>
                        </tr>
                        <tr>
                          <td>
                            {"TS사업부"}
                          </td>
                          <td>
                            {"메시지 발송 이력"}
                          </td>
                          <td>
                            <ul className="list_left">
                              <li>
                                {"전화:070-8896-7359"}
                              </li>
                              <li>
                                {"이메일:biztalk_privacy@biztalk.co.kr"}
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </dd>
                </dl>
                <dl className="main" id="no11">
                  <dt>
                    {"11. 권익침해 구제방법"}
                  </dt>
                  <dd>
                    {"① 정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다."}
                  </dd>
                </dl>
                <dl className="item">
                  <dd>
                    {"1. 개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)"}
                  </dd>
                  <dd>
                    {"2. 개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)"}
                  </dd>
                  <dd>
                    {"3. 대검찰청 : (국번없이) 1301 (www.spo.go.kr)"}
                  </dd>
                  <dd>
                    {"4. 경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)"}
                  </dd>
                </dl>
                <dl className="main" id="no12">
                  <dt>
                    {"12. 영상정보 처리기기 운영·관리 방침"}
                  </dt>
                  <dd>
                    {"본 방침은 개인정보 보호법 제25조에 따라 비즈톡 주식회사(이하 ‘회사’라 합니다.)영상정보처리기기를 설치·운영함에 있어 지켜야 할 사항을 규정하여 영상정보가 개인의 권리와 자유를 침해하지 않도록 함을 목적으로 합니다."}
                  </dd>
                </dl>
                <dl className="item">
                  <dt>
                    {"① 영상정보처리기기의 설치 근거 및 목적"}
                  </dt>
                  <dd>
                    {"회사는 「개인정보 보호법」 제25조 제1항에 따라 다음과 같은 목적으로 영상정보처리기기를 설치·운영합니다."}
                  </dd>
                  <ul>
                    <li>
                      {"시설 안전 및 화재 예방"}
                    </li>
                    <li>
                      {"고객 및 임직원의 안전을 위한 범죄 예방"}
                    </li>
                    <li>
                      {"회사의 유∙무형 자산 보호 및 정보유출 사고 예방"}
                    </li>
                  </ul>
                  <dt>
                    {"② 설치 대수, 설치 위치 및 촬영 범위"}
                  </dt>
                  <dd>
                    <table className="item-table cctv-table">
                      <tbody>
                        <tr>
                          <th>
                            {"설치 대수"}
                          </th>
                          <td>
                            {"3대"}
                          </td>
                        </tr>
                        <tr>
                          <th>
                            {"설치 위치 및"}
                            <br />
                            {"촬영 범위"}
                          </th>
                          <td>
                            {"출입구, SOC, OA"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </dd>
                  <dd>
                    {"※ 안내판 설치: 영상정보처리기기가 설치된 장소에는 정보주체가 쉽게 인식할 수 있도록 안내판을 설치합니다."}
                  </dd>
                  <dt>
                    {"③ 관리책임자 및 담당 부서"}
                  </dt>
                  <dd>
                    {"귀하의 영상정보를 안전하게 보호하고 개인정보 처리에 관한 불만을 처리하기 위하여 다음과 같이 관리 책임자를 지정하고 있습니다."}
                  </dd>
                  <dd>
                    <table className="item-table cctv-table">
                      <tbody>
                        <tr>
                          <th>
                            {"관리 책임자"}
                          </th>
                          <td>
                            {"성명 / 직급 : 정의영 대표"}
                            <br />
                            {"연락처 : 1688-3764"}
                          </td>
                        </tr>
                        <tr>
                          <th>
                            {"담당 부서"}
                          </th>
                          <td>
                            {"비즈톡 정보보호파트"}
                            <br />
                            {"연락처 : 070-8896-7539"}
                            <br />
                            {"이메일 :  biztalk_privacy@biztalk.co.kr"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </dd>
                  <dt>
                    {"④ 영상정보의 촬영 시간, 보관 기간, 보관 장소 및 처리 방법"}
                  </dt>
                  <dd>
                    <table className="item-table cctv-table">
                      <tbody>
                        <tr>
                          <th>
                            {"촬영 시간"}
                          </th>
                          <td>
                            {"24시간"}
                          </td>
                        </tr>
                        <tr>
                          <th>
                            {"보관 기간"}
                          </th>
                          <td>
                            {"촬영일로부터 30일"}
                          </td>
                        </tr>
                        <tr>
                          <th>
                            {"보관 장소"}
                          </th>
                          <td>
                            {"관제센터"}
                          </td>
                        </tr>
                        <tr>
                          <th>
                            {"처리 방법"}
                          </th>
                          <td>
                            {"개인정보의 목적 외 이용, 제3자 제공, 파기, 열람 요구 등을 기록·관리하고,"}
                            <br />
                            {"보관기간 만료 시 복원이 불가능한 방법으로 영구 삭제합니다."}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </dd>
                  <dt>
                    {"⑤ 개인 영상정보 확인 방법 및 장소에 관한 사항"}
                  </dt>
                  <dd>
                    {"확인 방법: 영상정보 담당부서에게 사전 연락 후 방문하시면 확인 가능합니다."}
                  </dd>
                  <dd>
                    {"확인 장소: 별도로 연락"}
                  </dd>
                  <dt>
                    {"⑥ 정보주체의 영상정보 열람 등 요구에 대한 조치"}
                  </dt>
                  <dd>
                    {"정보주체는 본인의 개인 영상정보에 대해 열람 또는 존재 확인·삭제를 요구할 수 있습니다."}
                    <br />
                    {"단, 본인 영상정보 및 긴급한 생명·신체·재산 보호가 필요한 경우에 한합니다."}
                    <br />
                    {"회사는 이에 대해 지체 없이 필요한 조치를 하겠습니다."}
                  </dd>
                  <dt>
                    {"⑦ 영상정보의 안전성 확보 조치"}
                  </dt>
                  <dd>
                    <ul>
                      <li>
                        {"영상정보는 암호화 등을 통해 안전하게 관리됩니다."}
                      </li>
                      <li>
                        {"접근 권한 차등 부여 및 접근 기록 관리"}
                      </li>
                      <li>
                        {"영상정보 생성 일시, 열람 목적 및 기록 보관"}
                      </li>
                      <li>
                        {"물리적 보관시설(잠금장치 등) 설치 및 CCTV 안내판 부착"}
                      </li>
                    </ul>
                  </dd>
                  <dt>
                    {"⑧ 영상정보처리기기 설치 및 운영 사무의 위탁"}
                  </dt>
                  <dd>
                    <table className="item-table cctv-table">
                      <tbody>
                        <tr>
                          <th>
                            {"수탁업체"}
                          </th>
                          <td>
                            {"수탁업체 명 : SK쉴더스"}
                            <br />
                            {"연락처 : 1800-6400"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </dd>
                </dl>
                <dl className="main" id="no13">
                  <dt>
                    {"13. 개인정보 처리방침의 변경"}
                  </dt>
                  <dd>
                    {"- 공고일자 : 2025년 07월 18일"}
                  </dd>
                  <dd>
                    {"- 시행일자 : 2025년 08월 19일"}
                  </dd>
                </dl>
              </article>
            </div>
          </div>
        </div>
      </section>
      <button type="button" className="toTop" data-scroll-top="true" style={{ border: "0"  }}>
        {"↑"}
      </button>
    </main>
    <div id="simpleModal" className="modal fs-6" tabIndex={-1} aria-hidden="true" style={{ display: "none"  }}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {"개인정보처리방침 변경사항"}
            </h5>
            <button type="button" className="btn close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                {"X"}
              </span>
            </button>
          </div>
          <div className="modal-body">
            <p>
              {"2025.07.18 변경사항"}
            </p>
            <p></p>
            <ul>
              <li style={{ color: "blue"  }}>
                <b>
                  {"수탁업체 엔아이티소프트, BGF네트웍스 추가"}
                </b>
              </li>
              <li style={{ color: "blue"  }}>
                <b>
                  {"보유 및 이용 기간 항목 법적 조항 표기"}
                </b>
              </li>
              <li style={{ color: "blue"  }}>
                <b>
                  {"개인정보 보호담당자 정보 변경"}
                </b>
              </li>
              <li style={{ color: "blue"  }}>
                <b>
                  {"제12조 영상정보 처리기기 운영·관리 방침 조항 추가"}
                </b>
              </li>
            </ul>
            <p></p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" id="modal-today-close">
              {"오늘하루 안보기"}
            </button>
            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">
              {"닫기"}
            </button>
          </div>
        </div>
      </div>
    </div>
    </ClauseStaticDocument>
  );
};

export default PrivacyV10Document;
